<div class="dialog-content-wrapper">
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row class="flex flex-row justify-between items-center flex-1">
      <span i18n class="title dialog-title">Оплата через PayPal</span>
      <button mat-button class="mat-icon-button" (click)="dialogRef.close(false)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-4 pb-0 m-0" fusePerfectScrollbar>
    <ng-container>
      <p i18n class="mat-body-1"
        >Введите сумму, которую вы хотите оплатить. После нажатия кнопки "Перейти к оплате" вы будете перенаправлены на
        сайт платёжной системы PayPal для совершения платежа.</p
      >
      <p class="mat-body-1 warning-text" *ngIf="paymentFeeMsg !== ''">{{ paymentFeeMsg }}</p>

      <form
        method="post"
        action="https://www.paypal.com/cgi-bin/webscr"
        #formPayPal
        class="flex flex-col justify-around">
        <input name="cmd" value="_xclick" hidden />
        <input name="no_note" value="1" hidden />
        <input name="no_shipping" value="1" hidden />
        <input name="button_subtype" value="services" hidden />
        <input name="currency_code" value="{{ responseData.currancy }}" hidden />
        <input name="business" value="{{ responseData.company }}" hidden />
        <input i18n-value name="item_name" value="Оплата заказа №{{ data.orderNumber }}" hidden />
        <input name="item_number" value="{{ responseData.order }}" hidden />
        <input name="return" value="{{ responseData.returnUrl }}" hidden />
        <input name="notify_url" value="{{ responseData.backendUrl }}" hidden />
        <input name="cancel_return" value="{{ responseData.returnUrl }}" hidden />
        <input name="bn" value="PP-BuyNowBF:btn_buynowCC_LG.gif:NonHostedGuest" hidden />

        <mat-form-field class="flex-1">
          <input i18n matInput name="amount" [formControl]="amount" required placeholder="Сумма" i18n-placeholder />
          <span matSuffix>{{ currentCurrencySign }}</span>
          <mat-error *ngIf="amount.invalid">{{ getErrorMessage() }}</mat-error>
        </mat-form-field>
      </form>
    </ng-container>
  </div>

  <div mat-dialog-actions class="m-0 p-4 flex flex-row justify-end items-center">
    <button
      i18n
      type="button"
      mat-raised-button
      class="mat-accent mr-4"
      [disabled]="amount.invalid"
      (click)="payPalPayClick()"
      >ПЕРЕЙТИ К ОПЛАТЕ</button
    >
    <button i18n type="button" mat-button (click)="dialogRef.close(false)">ОТМЕНА</button>
  </div>
</div>
